import React, { useState } from 'react';
import { Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { Home, AddCircle, Download, Person } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // URL के आधार पर एक्टिव टैब सेट करना
  const currentTab = location.pathname;

  return (
    <Paper 
      sx={{ 
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000,
        display: { xs: 'block', md: 'none' }, // सिर्फ मोबाइल पर दिखेगा
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)' 
      }} 
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={currentTab}
        onChange={(event, newValue) => {
          navigate(newValue);
        }}
        sx={{
          '& .Mui-selected': { color: '#ff8f00' }, // Active color
          '& .MuiBottomNavigationAction-root': { color: '#6c757d', minWidth: 'auto' }
        }}
      >
        <BottomNavigationAction label="होम" value="/" icon={<Home />} />
        <BottomNavigationAction label="बनाएं" value="/my-designs" icon={<AddCircle />} />
        <BottomNavigationAction label="डाउनलोड" value="/download" icon={<Download />} />
        <BottomNavigationAction label="मैं" value="/my-profile" icon={<Person />} />
      </BottomNavigation>
    </Paper>
  );
}